import { Global } from '@emotion/react';

export function DisableAngularModalBackdrop(): JSX.Element {
  return (
    <Global
      styles={{
        // This modal is, for now, displayed as part of legacy Angular modal.
        //   We're turning off the backdrop of this legacy modal
        '.modal-backdrop': {
          opacity: '0 !important',
        },
      }}
    />
  );
}
